<template>
  <div class="d-flex justify-center actions-bar">
    <NewMessageTemplateDialog @close="closeDialog" :isOpen="isOpen" />
    <SecondaryButton
      @click.native="openDialog"
      permission="create"
      color="primary"
    >
      <div class="d-flex align-center justify-center">
        <v-icon>mdi-message-processing-outline</v-icon>
        <v-icon small>mdi-plus</v-icon>
      </div>
      New Message Template
    </SecondaryButton>
  </div>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import NewMessageTemplateDialog from "@/views/settings/components/message-templates/components/dialogs/NewMessageTemplateDialog";

export default {
  components: {
    NewMessageTemplateDialog,
    SecondaryButton
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
<style lang="scss"></style>
